import PropTypes from 'prop-types';
// @mui
import Stack from '@mui/material/Stack';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import LinearProgress from '@mui/material/LinearProgress';
// utils
import { fPercent, fCurrency } from 'src/utils/format-number';

// ----------------------------------------------------------------------

export default function EcommerceSalesOverview({ title, subheader, data, ...other }) {
  return (
    <Card { ...other }>
      <CardHeader title={ title } subheader={ subheader } />

      <Stack spacing={ 4 } sx={ { px: 3, pt: 3, pb: 5 } }>
        { data.map((progress) => (
          <ProgressItem key={ progress.label } progress={ progress } />
        )) }
      </Stack>
    </Card>
  );
}

EcommerceSalesOverview.propTypes = {
  data: PropTypes.array,
  subheader: PropTypes.string,
  title: PropTypes.string,
};

// ----------------------------------------------------------------------

function ProgressItem({ progress }) {
  return (
    <Stack spacing={ 1 }>
      <Stack direction="row" alignItems="center">
        <Typography variant="subtitle2" sx={ { flexGrow: 1 } }>
          { progress.label }
        </Typography>

        <Typography variant="subtitle2">{ 0 }</Typography>

        <Typography variant="body2" sx={ { color: 'text.secondary' } }>
          {/* &nbsp;(0) */ }
        </Typography>
      </Stack>

      <LinearProgress
        variant="determinate"
        value={ progress.value }
        color={
          (progress.label === 'Total Income' && 'info') ||
          (progress.label === 'Total Expenses' && 'warning') ||
          'primary'
        }
      />
    </Stack>
  );
}

ProgressItem.propTypes = {
  progress: PropTypes.object,
};
